import styles from './RouteErrorBoundary.module.css';

import * as Sentry from '@sentry/react';
import { useEffect, type JSX } from 'react';
import { useRouteError } from 'react-router';

export function RouteErrorBoundary(): JSX.Element {
  const error = useRouteError();

  useEffect(() => {
    if (error instanceof Error) {
      Sentry.captureException(error);
    }
  }, [error]);

  return (
    <div className="content-wrapper">
      <div className={styles.container}>
        <h2>An error occurred while loading the page</h2>

        <p>
          Please try refreshing the page or{' '}
          <a href="mailto:info@kilotype.com">contact us</a> if the problem
          persists.
        </p>

        <hr className={styles.rule} />

        <h2>Beim Laden der Seite ist ein Fehler aufgetreten</h2>

        <p>
          Bitte versuchen Sie, die Seite neu zu laden, oder{' '}
          <a href="mailto:info@kilotype.com">kontaktieren Sie uns</a>, falls das
          Problem weiterhin besteht.
        </p>
      </div>
    </div>
  );
}
